import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


const CustomerPackagingSites = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  let customer_id = localStorage.getItem("customer_id");
  
  const formData =({
    customer:customer_id,    
  });
  useEffect(() => {

    axios.post("/customerportal/locations/listings",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.locations);
        }
        else  if (response.data.code === 401) {
         window.location.href = "/customerportal/login";
        }else{
          window.location.href = "/customerportal/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const FarmNameCell = ({ row }) => {
    return (
      <a href={`/customerportal/packing-sites-view/${row.original.id}`}>
        {row.original.title}
      </a>
    );
  };
  
  FarmNameCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
      }),
    }).isRequired,
  };
const columns =
 [
 
  {
    header: 'Location Name',
    accessorFn: (row) => row.title,
    Cell: FarmNameCell,
  }
  ,
 {
      accessorKey: 'gps_location', //normal accessorKey
      header: 'GPS Location',
    },
    {
      accessorKey: 'numero_de_station', //normal accessorKey
      header: 'Numero De Station',
    },
    {
      accessorKey: 'n_onssa', //normal accessorKey
      header: 'N ONSSA',
    },
    {
      accessorKey: 'n_exportateur', //normal accessorKey
      header: 'N° Exportateur',
    },
    {
      accessorKey: 'description', //normal accessorKey
      header: 'Description',
    },
 
  ];

  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Packing Sites</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                  <Link to="/customerportal/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Packing Sites</li>
                </ul>
              </div>
             
            </div>
          </div>

          <div className="row">
           
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                    enableColumnOrdering
                    enablePinning
                 
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerPackagingSites;
